const CovidTotalsTable = () => import(/* webpackChunkName: "CovidCovidTotalsTable" */ "./CovidTotalsTable.vue");
const CovidUsaTotalsTable = () => import(/* webpackChunkName: "CovidCovidUsaTotalsTable" */ "./CovidUsaTotalsTable.vue");
const CovidHp = () => import(/* webpackChunkName: "CovidCovidHp" */ "./CovidHp.vue");
const CovidRecirc = () => import(/* webpackChunkName: "CovidCovidRecirc" */ "./CovidRecirc.vue");

function init_usa_covid_table(selector){
    new Vue({
        name: 'usa-covid-table-app',
        el: selector,
        render: h => h(CovidUsaTotalsTable, {
            props: {
                "show-header": false,
                wide: true,
            },
        }),
    });
}

function init_world_covid_table(selector){
    new Vue({
        name: 'world-covid-table-app',
        el: selector,
        render: h => h(CovidTotalsTable, {
            props: {
                "show-header": false,
                wide: true,
            },
        }),
    });
}

function init_recirc(selector){
    new Vue({
        name: 'covid-recirc-app',
        el: selector,
        render: h => h(CovidRecirc),
    });
}

function init_covid_hp_table(selector){
    new Vue({
        name: 'covid-hp-app',
        el: selector,
        components: {
            'covid-hp': CovidHp,
        }, 
    });
}

function lazy_init_covid_table(selector, callback){

    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(50) ){
            callback(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_covid_app(){

    if( document.querySelector('#covid_usa_totals_table') !== null ) {

        lazy_init_covid_table('#covid_usa_totals_table', init_usa_covid_table);
    }
    
    if( document.querySelector('#covid_totals_table') !== null ) {

        lazy_init_covid_table('#covid_totals_table', init_world_covid_table);
    }

    if( document.querySelector('#covid_recirc_posts') !== null ) {

        lazy_init_covid_table('#covid_recirc_posts', init_recirc);
    }

    if( document.querySelector('covid-hp') !== null ){

        var init_now = false;
        if( typeof in_iframe_template !== 'undefined' && in_iframe_template == true ){
            init_now = true;
        }

        var covid_els = document.querySelectorAll('covid-hp');
        for (var i = 0; i < covid_els.length; i++) {

            if( init_now ){
                init_covid_hp_table(covid_els[i]);
            }else{
                lazy_init_covid_table(covid_els[i], init_covid_hp_table);
            }
        }

    }

}

export default init_covid_app;